'use strict';

// Constructor
var CampaignRelated = function () {
    $('.related-content .inner').matchHeight();
};

module.exports = CampaignRelated;
